define(["exports", "react", "styled-components"], function (_exports, _react, _styledComponents) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ContentPlaceholder = void 0;
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);
  var InfiniteFade = (0, _styledComponents.keyframes)(["from{opacity:0.4;}to{opacity:1;}"]);

  var TitleStyled = _styledComponents.default.div.withConfig({
    displayName: "ContentPlaceholder__TitleStyled",
    componentId: "sc-pt1fzu-0"
  })(["align-content:center;animation:", " 0.4s linear infinite both alternate;display:flex;padding:14px 16px 13px;"], InfiniteFade);

  var MiniCv = _styledComponents.default.div.withConfig({
    displayName: "ContentPlaceholder__MiniCv",
    componentId: "sc-pt1fzu-1"
  })(["animation:", " 0.4s linear 0.2s infinite both alternate;padding-top:24px;+ div{border-bottom:solid 1px ", ";}"], InfiniteFade, function (_ref) {
    var theme = _ref.theme;
    return theme.colors.lightGray;
  });

  var Resume = _styledComponents.default.div.withConfig({
    displayName: "ContentPlaceholder__Resume",
    componentId: "sc-pt1fzu-2"
  })(["animation:", " 0.4s linear 0.2s infinite both alternate;border-top:solid 1px ", ";padding:32px 24px 24px;width:100%;"], InfiniteFade, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.gray;
  });

  var ResumeButton = _styledComponents.default.div.withConfig({
    displayName: "ContentPlaceholder__ResumeButton",
    componentId: "sc-pt1fzu-3"
  })(["padding:8px;"]);

  var Svg = _styledComponents.default.svg.withConfig({
    displayName: "ContentPlaceholder__Svg",
    componentId: "sc-pt1fzu-4"
  })(["width:100%;display:block;"]);

  var VacanciesLoad = _styledComponents.default.div.withConfig({
    displayName: "ContentPlaceholder__VacanciesLoad",
    componentId: "sc-pt1fzu-5"
  })(["animation:", " 0.4s linear 0.2s infinite both alternate;display:block;margin:24px 0 0;width:100%;"], InfiniteFade);

  var GroupTitle = _styledComponents.default.div.withConfig({
    displayName: "ContentPlaceholder__GroupTitle",
    componentId: "sc-pt1fzu-6"
  })(["animation:", " 0.4s linear 0.2s infinite both alternate;display:block;margin:24px auto;max-width:657px;width:500%;"], InfiniteFade);

  var CandidateHistoryLoad = _styledComponents.default.div.withConfig({
    displayName: "ContentPlaceholder__CandidateHistoryLoad",
    componentId: "sc-pt1fzu-7"
  })(["animation:", " 0.4s linear 0.2s infinite both alternate;display:block;margin:24px auto;max-width:657px;width:500%;"], InfiniteFade);

  var ContentPlaceholder = function ContentPlaceholder(_ref3) {
    var kind = _ref3.kind;

    switch (kind) {
      case 'asideTitle':
        return /*#__PURE__*/_react.default.createElement(TitleStyled, null, /*#__PURE__*/_react.default.createElement(Svg, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "118",
          height: "13"
        }, /*#__PURE__*/_react.default.createElement("rect", {
          width: "118",
          height: "13",
          x: "17",
          y: "17",
          fill: "#EEE",
          fillRule: "evenodd",
          rx: "2",
          transform: "translate(-17 -17)"
        })));

      case 'minicv':
        return /*#__PURE__*/_react.default.createElement(MiniCv, null, /*#__PURE__*/_react.default.createElement(Svg, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "371",
          height: "142"
        }, /*#__PURE__*/_react.default.createElement("g", {
          fill: "none",
          fillRule: "evenodd"
        }, /*#__PURE__*/_react.default.createElement("circle", {
          cx: "84",
          cy: "105",
          r: "12",
          fill: "#EEE"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "84",
          cy: "65",
          r: "12",
          fill: "#EEE"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#EEE",
          d: "M0 141h371v1H0z"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "118",
          height: "16",
          x: "72",
          fill: "#EEE",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "208",
          height: "13",
          x: "72",
          y: "24",
          fill: "#EEE",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "208",
          height: "13",
          x: "104",
          y: "59",
          fill: "#EEE",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "118",
          height: "13",
          x: "104",
          y: "99",
          fill: "#EEE",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "36",
          cy: "20",
          r: "20",
          fill: "#EEE"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#FFF",
          fillRule: "nonzero",
          d: "M29 27.2c0 .442.351.8.784.8h12.548a.792.792 0 0 0 .784-.8v-.8c0-2.971-1.773-5.526-4.296-6.625a4.429 4.429 0 0 0 1.55-3.375c0-2.426-1.935-4.4-4.313-4.4-2.379 0-4.313 1.974-4.313 4.4a4.43 4.43 0 0 0 1.55 3.375C30.774 20.875 29 23.43 29 26.4v.8zm4.313-10.8c0-1.544 1.231-2.8 2.745-2.8 1.513 0 2.745 1.256 2.745 2.8 0 1.544-1.232 2.8-2.745 2.8-1.514 0-2.745-1.256-2.745-2.8zm2.745 4.4c3.026 0 5.49 2.513 5.49 5.6h-10.98c0-3.087 2.463-5.6 5.49-5.6z"
        }))));

      case 'resume':
        return /*#__PURE__*/_react.default.createElement(Resume, null, /*#__PURE__*/_react.default.createElement(Svg, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "713",
          height: "678"
        }, /*#__PURE__*/_react.default.createElement("g", {
          fill: "none",
          fillRule: "evenodd"
        }, /*#__PURE__*/_react.default.createElement("g", {
          fill: "#EEE",
          transform: "translate(0 587)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M2 32h341a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm0 21h331a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2z"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "178",
          height: "16",
          x: "1",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 90h430v1H0z"
        })), /*#__PURE__*/_react.default.createElement("g", {
          fill: "#EEE",
          transform: "translate(0 186)"
        }, /*#__PURE__*/_react.default.createElement("rect", {
          width: "178",
          height: "16",
          x: "1",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M90 54h241a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H90a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm0 79h341a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H90a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm0 21h331a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H90a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm0 21h336a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H90a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm0-100h151a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H90a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm0 21h91a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H90a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zM0 376h429v1H0zM0 48h72v72H0zm90 170h241a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H90a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm0 79h341a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H90a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm0 21h331a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H90a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm0 21h336a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H90a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm0-100h151a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H90a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm0 21h91a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H90a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zM0 212h72v72H0z"
        })), /*#__PURE__*/_react.default.createElement("g", {
          transform: "translate(8)"
        }, /*#__PURE__*/_react.default.createElement("circle", {
          cx: "385",
          cy: "73",
          r: "12",
          fill: "#EEE"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "121",
          cy: "73",
          r: "12",
          fill: "#EEE"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "118",
          height: "16",
          x: "109",
          y: "8",
          fill: "#EEE",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "388",
          height: "13",
          x: "109",
          y: "32",
          fill: "#EEE",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "208",
          height: "13",
          x: "141",
          y: "67",
          fill: "#EEE",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "118",
          height: "13",
          x: "405",
          y: "67",
          fill: "#EEE",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "43",
          cy: "43",
          r: "43",
          fill: "#EEE"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#FFF",
          fillRule: "nonzero",
          d: "M27.784 59.347c0 .962.764 1.739 1.705 1.739h27.267c.943 0 1.704-.777 1.704-1.739V57.61c0-6.457-3.853-12.008-9.335-14.397a9.625 9.625 0 0 0 3.37-7.335c0-5.271-4.205-9.562-9.373-9.562-5.169 0-9.373 4.29-9.373 9.562a9.625 9.625 0 0 0 3.371 7.335c-5.482 2.389-9.336 7.942-9.336 14.397v1.738zm9.374-23.47c0-3.355 2.675-6.085 5.964-6.085 3.29 0 5.965 2.73 5.965 6.085s-2.675 6.085-5.965 6.085c-3.289 0-5.964-2.73-5.964-6.085zm5.964 9.562c6.577 0 11.93 5.46 11.93 12.17h-23.86c0-6.71 5.352-12.17 11.93-12.17z"
        })), /*#__PURE__*/_react.default.createElement("g", {
          fill: "#EEE",
          transform: "translate(478 186)"
        }, /*#__PURE__*/_react.default.createElement("circle", {
          cx: "12",
          cy: "97",
          r: "12"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "150",
          height: "13",
          x: "32",
          y: "91",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "12",
          cy: "129",
          r: "12"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "104",
          height: "13",
          x: "32",
          y: "123",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "12",
          cy: "161",
          r: "12"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "136",
          height: "13",
          x: "32",
          y: "155",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "12",
          cy: "193",
          r: "12"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "112",
          height: "13",
          x: "32",
          y: "187",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "16",
          cy: "16",
          r: "16",
          stroke: "#FFF",
          strokeWidth: "2",
          transform: "translate(0 29)"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "16",
          cy: "16",
          r: "16",
          stroke: "#FFF",
          strokeWidth: "2",
          transform: "translate(56 29)"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "16",
          cy: "16",
          r: "16",
          stroke: "#FFF",
          strokeWidth: "2",
          transform: "translate(112 29)"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "16",
          cy: "16",
          r: "16",
          stroke: "#FFF",
          strokeWidth: "2",
          transform: "translate(168 29)"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M2 0h123a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"
        })), /*#__PURE__*/_react.default.createElement("g", {
          fill: "#EEE",
          transform: "translate(0 121)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 31h713v2H0z"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "74",
          height: "13",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M100 0h160a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H100a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm188 0h146a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H288a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm174 0h58a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-58a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"
        })))));

      case 'resumeButtons':
        return /*#__PURE__*/_react.default.createElement(ResumeButton, null, /*#__PURE__*/_react.default.createElement(Svg, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "311",
          height: "32"
        }, /*#__PURE__*/_react.default.createElement("g", {
          fill: "none",
          fillRule: "evenodd",
          transform: "translate(-8 -8)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M4 0h753a4 4 0 0 1 4 4v44H0V4a4 4 0 0 1 4-4z"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "146",
          height: "31",
          x: "8.5",
          y: "8.5",
          stroke: "#EEE",
          rx: "4"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "155",
          height: "31",
          x: "163.5",
          y: "8.5",
          stroke: "#EEE",
          opacity: ".8",
          rx: "4"
        }))));

      case 'vacanciesLoad':
        return /*#__PURE__*/_react.default.createElement(VacanciesLoad, null, /*#__PURE__*/_react.default.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "252",
          height: "80"
        }, /*#__PURE__*/_react.default.createElement("g", {
          fill: "none",
          fillRule: "evenodd"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fill: "#C8C8C8",
          fillRule: "nonzero",
          d: "M8 0C3.589 0 0 3.59 0 8s3.589 8 8 8c4.41 0 8-3.59 8-8s-3.59-8-8-8zm0 13.714A5.72 5.72 0 0 1 2.286 8 5.72 5.72 0 0 1 8 2.286 5.72 5.72 0 0 1 13.714 8 5.72 5.72 0 0 1 8 13.714z"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "198",
          height: "16",
          x: "24",
          fill: "#E6E6E6",
          rx: "8"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#C8C8C8",
          fillRule: "nonzero",
          d: "M8 32c-4.411 0-8 3.59-8 8s3.589 8 8 8c4.41 0 8-3.59 8-8s-3.59-8-8-8zm0 13.714A5.72 5.72 0 0 1 2.286 40 5.72 5.72 0 0 1 8 34.286 5.72 5.72 0 0 1 13.714 40 5.72 5.72 0 0 1 8 45.714z"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "168",
          height: "16",
          x: "24",
          y: "32",
          fill: "#C8C8C8",
          opacity: ".6",
          rx: "8"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#C8C8C8",
          fillRule: "nonzero",
          d: "M8 64c-4.411 0-8 3.59-8 8s3.589 8 8 8c4.41 0 8-3.59 8-8s-3.59-8-8-8zm0 13.714A5.72 5.72 0 0 1 2.286 72 5.72 5.72 0 0 1 8 66.286 5.72 5.72 0 0 1 13.714 72 5.72 5.72 0 0 1 8 77.714z"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "228",
          height: "16",
          x: "24",
          y: "64",
          fill: "#C8C8C8",
          opacity: ".6",
          rx: "8"
        }))));

      case 'viewContact':
        return /*#__PURE__*/_react.default.createElement(VacanciesLoad, null, /*#__PURE__*/_react.default.createElement(Svg, {
          viewBox: "0 0 648 238",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/_react.default.createElement("g", {
          transform: "translate(1)",
          fill: "none",
          fillRule: "evenodd"
        }, /*#__PURE__*/_react.default.createElement("rect", {
          stroke: "#E6E6E6",
          x: ".5",
          y: ".5",
          width: "209",
          height: "31",
          rx: "15.5"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          stroke: "#E6E6E6",
          x: "218.5",
          y: ".5",
          width: "209",
          height: "31",
          rx: "15.5"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          stroke: "#E6E6E6",
          x: "436.5",
          y: ".5",
          width: "209",
          height: "31",
          rx: "15.5"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          fill: "#EEE",
          fillRule: "nonzero",
          y: "81",
          width: "298",
          height: "16",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          fill: "#EEE",
          fillRule: "nonzero",
          y: "176",
          width: "298",
          height: "16",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          fill: "#EEE",
          fillRule: "nonzero",
          x: "348",
          y: "82",
          width: "298",
          height: "16",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M0 56.5h646",
          stroke: "#E6E6E6",
          strokeLinecap: "square"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M2 105h204a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zM2 126h174a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zM2 204h174a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zM2 225h174a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2z",
          fill: "#EEE",
          fillRule: "nonzero"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          fill: "#EEE",
          fillRule: "nonzero",
          cx: "361",
          cy: "123",
          r: "12"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M383 117h214a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H383a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2z",
          fill: "#EEE",
          fillRule: "nonzero"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          fill: "#EEE",
          fillRule: "nonzero",
          cx: "361",
          cy: "155",
          r: "12"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M383 149h174a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H383a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2z",
          fill: "#EEE",
          fillRule: "nonzero"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          fill: "#EEE",
          fillRule: "nonzero",
          cx: "361",
          cy: "187",
          r: "12"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          fill: "#EEE",
          fillRule: "nonzero",
          x: "381",
          y: "181",
          width: "118",
          height: "13",
          rx: "2"
        }))));

      case 'labels':
        return /*#__PURE__*/_react.default.createElement(VacanciesLoad, null, /*#__PURE__*/_react.default.createElement(Svg, {
          viewBox: "0 0 250 88",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/_react.default.createElement("g", {
          fill: "#EEE",
          fillRule: "nonzero"
        }, /*#__PURE__*/_react.default.createElement("circle", {
          cx: "12",
          cy: "12",
          r: "12"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M34 6h214a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H34a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "12",
          cy: "44",
          r: "12"
        }), /*#__PURE__*/_react.default.createElement("path", {
          d: "M34 38h174a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H34a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2z"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          cx: "12",
          cy: "76",
          r: "12"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          x: "32",
          y: "70",
          width: "118",
          height: "13",
          rx: "2"
        }))));

      case 'groups':
        return /*#__PURE__*/_react.default.createElement(VacanciesLoad, null, /*#__PURE__*/_react.default.createElement(Svg, {
          viewBox: "0 0 169 78",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/_react.default.createElement("g", {
          transform: "translate(1)",
          fill: "#EEE",
          fillRule: "nonzero"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M2 0h164a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM2 24h114a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2z"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          stroke: "#FFF",
          cx: "12",
          cy: "65",
          r: "12"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          stroke: "#FFF",
          cx: "32",
          cy: "65",
          r: "12"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          stroke: "#FFF",
          cx: "53",
          cy: "65",
          r: "12"
        }), /*#__PURE__*/_react.default.createElement("circle", {
          stroke: "#FFF",
          cx: "74",
          cy: "65",
          r: "12"
        }))));

      case 'groupTitle':
        return /*#__PURE__*/_react.default.createElement(GroupTitle, null, /*#__PURE__*/_react.default.createElement(Svg, {
          viewBox: "0 0 657 30",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M2 0h653a2 2 0 0 1 2 2v26a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z",
          fill: "#c8c8c8",
          fillRule: "nonzero"
        })));

      case 'candidateHistory':
        return /*#__PURE__*/_react.default.createElement(CandidateHistoryLoad, null, /*#__PURE__*/_react.default.createElement(Svg, {
          xmlns: "http://www.w3.org/2000/svg",
          width: "712",
          height: "100",
          viewBox: "0 0 712 100"
        }, /*#__PURE__*/_react.default.createElement("g", {
          fill: "none",
          fillRule: "evenodd"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fill: "#FFF",
          stroke: "#E6E6E6",
          d: "M.5.5h165v99H.5zM182.5.5h165v99h-165zM364.5.5h165v99h-165z"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "117",
          height: "16",
          x: "396",
          y: "68",
          fill: "#E6E6E6",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#FFF",
          stroke: "#E6E6E6",
          d: "M546.5.5h165v99h-165z"
        }), /*#__PURE__*/_react.default.createElement("text", {
          fill: "#E6E6E6",
          fontFamily: "OpenSans-Bold, Open Sans",
          fontSize: "40",
          fontWeight: "bold"
        }, /*#__PURE__*/_react.default.createElement("tspan", {
          x: "32",
          y: "59"
        }, "0")), /*#__PURE__*/_react.default.createElement("text", {
          fill: "#E6E6E6",
          fontFamily: "OpenSans-Bold, Open Sans",
          fontSize: "40",
          fontWeight: "bold"
        }, /*#__PURE__*/_react.default.createElement("tspan", {
          x: "214",
          y: "59"
        }, "0")), /*#__PURE__*/_react.default.createElement("rect", {
          width: "117",
          height: "16",
          x: "214",
          y: "68",
          fill: "#E6E6E6",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("text", {
          fill: "#E6E6E6",
          fontFamily: "OpenSans-Bold, Open Sans",
          fontSize: "40",
          fontWeight: "bold"
        }, /*#__PURE__*/_react.default.createElement("tspan", {
          x: "396",
          y: "59"
        }, "0")), /*#__PURE__*/_react.default.createElement("text", {
          fill: "#E6E6E6",
          fontFamily: "OpenSans-Bold, Open Sans",
          fontSize: "40",
          fontWeight: "bold"
        }, /*#__PURE__*/_react.default.createElement("tspan", {
          x: "578",
          y: "59"
        }, "0")), /*#__PURE__*/_react.default.createElement("rect", {
          width: "117",
          height: "16",
          x: "578",
          y: "68",
          fill: "#E6E6E6",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "117",
          height: "16",
          x: "32",
          y: "68",
          fill: "#E6E6E6",
          rx: "2"
        }))), /*#__PURE__*/_react.default.createElement(Svg, {
          xmlns: "http://www.w3.org/2000/svg",
          xmlnsXlink: "http://www.w3.org/1999/xlink",
          width: "713",
          height: "266",
          viewBox: "0 0 713 266"
        }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("ellipse", {
          id: "a",
          cx: "15.684",
          cy: "16",
          rx: "15.684",
          ry: "16"
        }), /*#__PURE__*/_react.default.createElement("ellipse", {
          id: "b",
          cx: "15.684",
          cy: "16",
          rx: "15.684",
          ry: "16"
        })), /*#__PURE__*/_react.default.createElement("g", {
          fill: "none",
          fillRule: "evenodd"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fill: "#FFF",
          stroke: "#E6E6E6",
          d: "M329 90.5a1.5 1.5 0 0 1 1.5 1.5v72a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 164V92A1.5 1.5 0 0 1 2 90.5h327z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#E6E6E6",
          d: "M251 166h80a2 2 0 0 0 2-2V92a2 2 0 0 0-2-2h-80v76z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#FFF",
          stroke: "#E6E6E6",
          d: "M711 190.5a1.5 1.5 0 0 1 1.5 1.5v72a1.5 1.5 0 0 1-1.5 1.5H384a1.5 1.5 0 0 1-1.5-1.5v-72a1.5 1.5 0 0 1 1.5-1.5h327z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#E6E6E6",
          d: "M463 266h-80a2 2 0 0 1-2-2v-72a2 2 0 0 1 2-2h80v76zM357 50a2 2 0 0 1 2 2v190a2 2 0 0 1-4 0V52a2 2 0 0 1 2-2z"
        }), /*#__PURE__*/_react.default.createElement("use", {
          fill: "#E6E6E6",
          transform: "translate(341 112)",
          xlinkHref: "#a"
        }), /*#__PURE__*/_react.default.createElement("use", {
          fill: "#E6E6E6",
          transform: "translate(341 212)",
          xlinkHref: "#b"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "91",
          height: "24",
          x: "310",
          y: "50",
          fill: "#E6E6E6",
          rx: "2"
        }), /*#__PURE__*/_react.default.createElement("rect", {
          width: "254",
          height: "24",
          x: "222",
          fill: "#E6E6E6",
          rx: "2"
        }))));

      default:
        return null;
    }
  };

  _exports.ContentPlaceholder = ContentPlaceholder;
});